import { useNavigate } from 'react-router-dom';
import { HelpTip, SignInFlow } from '@dataroom/shared';
import { rememberBuyerEmail } from '@/lib/viewerIdentity';

/**
 * Buyer sign-in — email + password, or "Email me a code" (how an invited buyer
 * gets in the first time: enter the emailed 6-digit code, then choose a
 * password). The tenant is resolved from the email; an email in several
 * organizations gets a picker.
 */
export function LoginPage() {
  const navigate = useNavigate();
  return (
    <SignInFlow
      title="Buyer access"
      subtitle="Sign in to view the data room."
      startSlot={
        <p className="flex items-center gap-1 text-sm text-muted-foreground">
          First time here, or no password yet? <HelpTip id="buyer.login.email-code" />
        </p>
      }
      codeSlot={
        <p className="flex items-center gap-1 text-sm text-muted-foreground">
          Where do I find my code? <HelpTip id="buyer.login.code" />
        </p>
      }
      onSignedIn={(email) => {
        rememberBuyerEmail(email);
        navigate('/');
      }}
    />
  );
}
